import React, { PropTypes } from 'react';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { selectArea } from '../actions/index.js';

class MapBlock extends React.Component {
  constructor(props) {
    super(props);
    this.setSelectors = this.setSelectors.bind(this);
  }
  componentWillMount() {
    this.props.selectArea('Taipei_City');
  }
  setSelectors() {
    const areaArray = [].slice.call(document.querySelectorAll('.map-area'));
    areaArray.forEach((area) => {
      area.addEventListener('click', () => {
        if (typeof area.focus === 'function') {
          area.focus();
        } else {
          areaArray.forEach((a) => a.setAttribute('class', 'map-area'));
          area.setAttribute('class', 'map-area -focused');
        }
        this.props.selectArea(area.getAttribute('id'));
      });
      // area.onclick = () => {
      //   this.props.selectArea(area.getAttribute('id'));
      // };
    });
  }
  render() {
    const nameEn = this.props.data ? this.props.data.name_en.split('_') : null;
    // const lastElement = name_en.length - 1;
    const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (this.props.data ?
      <div className="map-background">
        <div className="map-block">
          <div className="location-title">
            <div className="name">{this.props.data.name}</div>
            <div className="name -en">{nameEn[0]}</div>
            <div className="type">{nameEn[1]}</div>
          </div>
          <div className="location-map">
            {/* <img src="./images/map_taiwan-04.svg" alt="台灣地圖" /> */}
            {/* <object type="image/svg+xml" data="./images/map-02.svg" /> */}
            <Isvg
              src="./images/taiwan-map.svg?v=2"
              uniquifyIDs={false}
              onLoad={this.setSelectors}
            />
          </div>
          <div className="location-infos">
            <div className="location-info">
              <span className="name">人口</span>
              <span className="number">{numberWithCommas(this.props.data.people)}</span>
              <span className="unit">人</span>
            </div>
            <div className="location-info">
              <span className="name">預算</span>
              <span className="number">{numberWithCommas(this.props.data.budget)}</span>
              <span className="unit">千元</span>
            </div>
            <div className="location-info">
              <span className="name">面積</span>
              <span className="number">{numberWithCommas(this.props.data.area)}</span>
              <span className="unit">平方公里</span>
            </div>
          </div>
        </div>
      </div> :
      null
    );
  }
}

MapBlock.propTypes = {
  selectArea: PropTypes.func,
  data: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    data: state.area.data,
  };
}

export default connect(mapStateToProps, { selectArea })(MapBlock);



/** WEBPACK FOOTER **
 ** ./src/components/map-block.js
 **/